/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

const FEATURED_WORKFLOW_BLOCK_PREFIX = 'fwb-';

/**
 * Load GeoJSON from one of the areas files.
 * @param {*} geoJson
 * @returns
 */
const loadGeojson = (geoJson) => {
    const gjv = require("geojson-validation");
    const reproject = require("reproject");
    const epsg = require("epsg") //EPSG definitions for Proj4JS, quite large

    let validateAndReverseGeoJson = (geoJson) => {
        if(gjv.valid(geoJson)){
            let convertedGeoJsonCRS = (geoJson) => {
                try {
                    let converted = reproject.toWgs84(geoJson, undefined, epsg); // detects defined crs in geojson and reprojects to wgs84
                    return converted;
                } catch (e) {
                    // if no coordinate reference system found in geoJson, assume already in wgs84
                    return(geoJson);
                }
            }

            // convert to wgs84 coordinate reference system
            let convertedGeoJson = convertedGeoJsonCRS(geoJson);
            let reversedGeoJson = reproject.reverse(convertedGeoJson); // reverse to lat, long as in EB
            return reversedGeoJson;
        } else {
            console.error(gjv.valid(geoJson, true)) // returns error trace
            return false;
        }
    }

    return validateAndReverseGeoJson(geoJson);
}

export {
    loadGeojson,
    FEATURED_WORKFLOW_BLOCK_PREFIX
}
